/* src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss */
:host {
  display: block;
  height: 100%;
}
.parent {
  height: 100%;
}
.item-selectable-article {
  height: 100%;
  position: relative;
  margin: 0 auto;
  padding: 8%;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  border: 1px solid #00FFFF;
  border-radius: 8px;
  transition: background 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #23262C;
}
@media (min-width: 991px) {
  .item-selectable-article {
    cursor: pointer;
  }
  .item-selectable-article:hover {
    border: 1px solid var(--color-black);
  }
}
.item-selectable-article.selected {
  border: 2px solid var(--ion-color-primary);
}
.item-selectable-article .wrapper-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item-selectable-article .footer-block {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 10px 2px 5px;
}
.item-selectable-article .footer-block .width-item {
  width: 20px;
}
.item-selectable-article .footer-block .option-item {
  font-size: 12px;
  height: 16px;
  color: #fff;
}
.item-selectable-article .footer-block .option-price {
  height: fit-content;
  font-size: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
  white-space: nowrap;
}
.item-selectable-article .footer-block .option-price.no-price {
  min-height: 12px;
  max-height: 12px;
}
.item-selectable-article .footer-block .added-item {
  display: flex;
  justify-content: flex-end;
}
.item-selectable-article .footer-block .added-item .selected-circle {
  border: 1px solid var(--color-black);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f6f1ef;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon {
  visibility: none;
  opacity: 0;
  transition: opacity 500ms ease-in-out;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon.selected {
  visibility: visible;
  opacity: 1;
}
.selected-block {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selected-block .info {
  height: 20px;
  width: 20px;
}
.selected-block .added-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
}
.selected-block .added-item .selected-text {
  font-size: 10px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: lowercase;
  margin-right: 5px;
}
.selected-block .added-item .selected-circle {
  height: 24px;
  width: 24px;
  border: 1px solid #000000;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-block .added-item .selected-circle ion-icon {
  width: 100%;
  height: 100%;
  scale: 0;
  transition: scale 0.3s ease-in-out;
}
.selected-block .added-item .selected-circle ion-icon.selected {
  scale: 1.15;
}
.name {
  min-height: 33px;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
  color: #fff;
}
.item-selectable-article-image {
  margin: 0 auto;
  height: 70px;
  max-width: 80px;
  object-fit: contain;
}
.item-selectable-article-image.default-img {
  width: 150px;
  object-fit: contain;
  --icon-color: black;
}
.wrapp {
  margin-top: 10px;
}
.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #fff;
  border-radius: 26px;
  width: fit-content;
  background: transparent;
  margin: auto;
}
.quantity-selector ion-icon {
  margin: 0 6px;
  cursor: pointer;
}
.quantity-selector {
  z-index: 999;
}
.quantity-selector .quantity {
  width: 30px;
  font-size: 15px;
  line-height: 85%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fff;
}
.quantity-selector .quantity-btn {
  width: 10px;
  height: 10px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}
.quantity-selector .quantity-btn {
  padding: 8px;
}
/*# sourceMappingURL=item-selectable-article-custom.component.css.map */
